'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CancelHoldButton = require('./components/CancelHoldButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CancelHoldButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/cancel-hold-button/lib/index.js
// module id = 1396
// module chunks = 1